import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RouteSEO from './components/RouteSEO';
import Home from './pages/Home';
import Tabela from './pages/Tabela';
import Pediatrica from './pages/Pediatrica';
import ECGP from './pages/ECGP';
import ComoAvaliar from './pages/ComoAvaliar';
import Sobre from './pages/Sobre';
import Referencias from './pages/Referencias';
import Privacidade from './pages/Privacidade';
import Termos from './pages/Termos';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h1>Erro ao carregar a aplicação</h1>
          <p>{this.state.error?.message}</p>
          <button onClick={() => window.location.reload()}>Recarregar página</button>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <RouteSEO />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tabela" element={<Tabela />} />
          <Route path="/pediatrica" element={<Pediatrica />} />
          <Route path="/ecg-p" element={<ECGP />} />
          <Route path="/como-avaliar" element={<ComoAvaliar />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/referencias" element={<Referencias />} />
          <Route path="/privacidade" element={<Privacidade />} />
          <Route path="/termos" element={<Termos />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
